// extracted by mini-css-extract-plugin
export default {"fadeContinuous":"Loader_fadeContinuous__6-IBV","fadeInOut":"Loader_fadeInOut__lhS6V","fadeWrapper":"Loader_fadeWrapper__4ip6t"};